// extracted by mini-css-extract-plugin
module.exports = {"container":"InterventionStatusBadge_container__10Vck","closedBadge":"InterventionStatusBadge_closedBadge__1q_-C","activeBadge":"InterventionStatusBadge_activeBadge__fjgnJ"};